import React, { useEffect, useState, useContext } from 'react'
import {
    BrowserRouter as Router,
    Link,
    Navigate,
    useNavigate,
    useParams
} from "react-router-dom"
import { subscribe } from "../utils/pubsub"
import CloudformationOutputs from '../CloudformationOutputs.json'
import FormatQuestionAnswer from '../checklists/FormatQuestionAnswer'
import Button from '../formfields/Button'
import SubNavigation from '../shared-components/SubNavigation'
import { GlobalContext } from '../GlobalContext'
import Card from '../ui-elements/Card'
import GreenAlert from '../ui-elements/GreenAlert'
import RedAlert from '../ui-elements/RedAlert'
import { getDate } from '../utils/getDate'
import { getDateFromMonthYearDay } from '../utils/getDateFromMonthYearDay'
import { getDaysInMonth } from '../utils/getDaysInMonth'
import { getStartAndEndTimestampsForDay } from '../utils/getStartAndEndTimestampsForDay'
import { getStartAndEndTimestampsForMonth } from '../utils/getStartAndEndTimestampsForMonth'
import Spinner from '../ui-elements/Spinner'
import FormatChecklistTimeWindow from '../checklists/FormatChecklistTimeWindow'
import FormatQuestionAnsweredBy from '../checklists/FormatQuestionAnsweredBy'
import YellowAlert from '../ui-elements/YellowAlert'
import Modal from '../ui-elements/Modal'
import { sortChecklistDataByTimePeriod } from '../checklists/checklist-utils/sortChecklistDataByTimePeriod'
import ProgressBar from '../formfields/ProgressBar'
import { removeNonAlphanumeric } from '../utils/removeNonAlphanumeric'



type Props = {
    checkperiodId: string
}

function CheckPeriodRequiringManagerSignoff({
    checkperiodId
}: Props) {

    const {
        tableData,
        currentOrganisation
    } = useContext(GlobalContext)

    const [answerNotes, setAnswerNotes] = useState<ObjectStringKeyAnyValue | null>(null)
    const [answerAlerts, setAnswerAlerts] = useState<Array<ObjectStringKeyAnyValue> | null>(null)
    const [showDetailsModal, setShowDetailsModal] = useState(false)

    const thisCheckPeriod = tableData && tableData.ChecklistPeriods && tableData.ChecklistPeriods[checkperiodId] ? tableData.ChecklistPeriods[checkperiodId] : null
    const isChecklistComplete = thisCheckPeriod && thisCheckPeriod.numberOfAnswers > 0 && thisCheckPeriod.numberOfAnswers === thisCheckPeriod.numberOfCompletedAnswers ? true : false
    const checklistName = tableData && tableData.Checklists && thisCheckPeriod && thisCheckPeriod.ChecklistId && tableData.Checklists[thisCheckPeriod.ChecklistId] && tableData.Checklists[thisCheckPeriod.ChecklistId].ChecklistName
    const signoffRequired = tableData && tableData.Organisation && tableData.Organisation.ChecklistOptions && tableData.Organisation.ChecklistOptions.RequireSignoff
    const cssId = checklistName ? `await-signoff-${removeNonAlphanumeric(checklistName)}` : ''

    function getNameForAsset(assetId: string) {
        if (tableData && tableData.Assets && tableData.Assets[assetId] && tableData.Assets[assetId].AssetName) {
            return tableData.Assets[assetId].AssetName
        }
        return assetId
    }

    const navigate = useNavigate()

    function getYearMonthDayFromTimestampMillis(timestamp: number) {
        const date = new Date(timestamp)
        const year = date.getFullYear()
        const month = date.getMonth() + 1
        const day = date.getDate()
        return [year, month, day]
    }


    function goToResults() {
        const checklistId = thisCheckPeriod.ChecklistId
        const StartTimeStamp = thisCheckPeriod.StartTimeStamp
        const [year, month, day] = getYearMonthDayFromTimestampMillis(StartTimeStamp)
        const path = `/checklists/${checklistId}/results/${year}/${month}/${day}`
        navigate(path)
    }


    return <div
        id={cssId}
        className={`w-full flex flex-col justify-between items-start gap-1 px-2 py-1 rounded border bg-yellow-100 border-yellow-500 text-yellow-700 hover:opacity-80 cursor-pointer`}
        onClick={goToResults}
    >

        <div className={`w-full flex flex-col gap-1`}>
            <div className={`w-full flex flex-col flex-wrap items-start`}>
                <p className={`text-sm`}>
                    {checklistName ? checklistName : `Checklist #${thisCheckPeriod.ChecklistId}`}
                    {thisCheckPeriod.AssetId && <> for {getNameForAsset(thisCheckPeriod.AssetId)}

                    </>}
                </p>
                <p className={`text-xs italic text-gray-600`}>
                    Check period:
                    <FormatChecklistTimeWindow thisCheckPeriod={thisCheckPeriod} hideAssetId={true} />
                </p>



            </div>

        </div>

        <div className={`flex flex-row gap-2`}>
            {thisCheckPeriod.alertsForCheckPeriod && thisCheckPeriod.alertsForCheckPeriod.length > 0 &&
                <RedAlert size='small'> {thisCheckPeriod.alertsForCheckPeriod.length} alerts</RedAlert>}


            {thisCheckPeriod.notesForCheckPeriod && thisCheckPeriod.notesForCheckPeriod.length > 0 &&
                <YellowAlert size='small'> {thisCheckPeriod.notesForCheckPeriod.length} notes</YellowAlert>}


        </div>
    </div>
}
export default CheckPeriodRequiringManagerSignoff